import { render, staticRenderFns } from "./LavApprovalStatus.vue?vue&type=template&id=3e88cb94&scoped=true"
import script from "./LavApprovalStatus.vue?vue&type=script&lang=js"
export * from "./LavApprovalStatus.vue?vue&type=script&lang=js"
import style0 from "./LavApprovalStatus.vue?vue&type=style&index=0&id=3e88cb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88cb94",
  null
  
)

export default component.exports